/* Native scrolling: card links and form controls retain normal browser behavior. */
(function () {
  function init(root) {
    root.querySelectorAll('[data-um-carousel]').forEach(function (controls) {
      if (controls.dataset.umReady) return;
      const track = document.getElementById(controls.dataset.umCarousel);
      if (!track) return;
      controls.dataset.umReady = 'true';
      const previous = controls.querySelector('[data-um-direction="-1"]');
      const next = controls.querySelector('[data-um-direction="1"]');
      function update() {
        const end = track.scrollWidth - track.clientWidth;
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = end <= 2 || track.scrollLeft >= end - 2;
      }
      controls.querySelectorAll('[data-um-direction]').forEach(function (button) {
        button.addEventListener('click', function () {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({ left: Number(button.dataset.umDirection) * track.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' });
        });
      });
      track.addEventListener('scroll', update, {passive:true});
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(track);
      }
      update();
    });
  }
  function start(){init(document);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
  document.addEventListener('change',function(event){
    if(!event.target.matches('[data-um-variant]')) return;
    const variant=event.target.form.querySelector('[data-um-current-variant]');
    if(variant){variant.value=event.target.value;variant.name='id';variant.disabled=!event.target.value;event.target.removeAttribute('name');}
    const quantity=event.target.form.querySelector('[data-um-quantity]');
    if(quantity) quantity.value=event.target.selectedOptions[0].dataset.min || '1';
  });
})();
